function CheckDirectorySearch() {
    var directorySearch = parseInt(tbSearch.getListOptionSelected('directory').replace('directory_', ''));
    var noteText = '';
    if (directorySearch == 0 || directorySearch == 2) {
        var searchZip = tbLocation.getValue('zip');
        if (searchZip.length < 5)
            noteText = 'You must enter a search zip code to view public subcontractors.';
    }

    if (noteText.length > 0) {
        jQuery('#directorySearchNoteText').html(noteText);
        jQuery('#top-note').removeClass('pjq-hidden');
    } else {
        jQuery('#top-note').addClass('pjq-hidden');
        jQuery('#directorySearchNoteText').html('');
    }
}

function InitContactProfile(contactCompanyId) {
    pjqContactCompanyId = contactCompanyId;
    InitViewProfile(true);
}

function InitEditDirectoryContactRegions() {
	let canEdit = false;
	if(editContact.IsPrivate || settings.IsDocumentClerk || (editContact.IsDirectory && settings.IsAllowDirectoryEdit)){
		canEdit = true;
	}
	window.regionsMapObj = new PJQ.views.workAreas.WorkAreaMap({
		el: $('#regionsOuterContainer'),
		contactId: editContact.ContactId,
		isInline: false,
		isEdit: canEdit,
		isSync: false,
		onChange: function(){
			EnableSave(true);
		}
	});
}